<template>
  <div :class="{ 'web-header': true, 'en-font': language == 'en', 'cn-font': language == 'cn' }">
    <div class="web-header-top">
      <div class="web-header-top-box">
        <div class="web-header-top-box-card">
          <a href="https://www.cf40.org.cn/" target="_blank" class="web-header-top-box-card-link" v-if="language == 'cn'">
            <div class="web-header-top-box-card-link-icon">
              <img src="~@/assets/cf40.png" />
            </div>
            <span class="web-header-top-box-card-link-text">中国金融四十人论坛</span>
          </a>
          <a href="https://en.cf40.com/" target="_blank" class="web-header-top-box-card-link" v-else>
            <div class="web-header-top-box-card-link-icon">
              <img src="~@/assets/cf40.png" />
            </div>
            <span class="web-header-top-box-card-link-text roboto-light">CHINA FINANCE 40 FORUM</span>
          </a>
          <a href="/en" class="web-header-top-box-card-switch" v-if="language == 'cn'">
            EN
          </a>
          <a href="/" class="web-header-top-box-card-switch roboto-light" v-else>
            CN
          </a>
        </div>
      </div>
    </div>
    <div class="web-header-content">
      <div :class="{ 'web-header-content-box': true, 'is-login': info.mobile || info.email }">
        <a href="/" class="web-header-content-box-cn_logo" v-if="language == 'cn'">
          <img src="~@/assets/chinese_logo.png" alt="CF40 研究" />
        </a>
        <a href="/en" class="web-header-content-box-en_logo" v-else>
          <img src="~@/assets/english_logo.png" alt="CF40 RESEARCH" />
        </a>
        <div class="web-header-content-box-opera">
          <div class="web-header-content-box-opera-search" v-if="searchVisible">
            <el-input v-model.trim="keywords" prefix-icon="el-icon-search" :placeholder="language == 'cn' ? '请输入关键词' : 'keywords'" @keyup.native.enter="searchData" @clear="searchData" clearable></el-input>
          </div>
          <div class="web-header-content-box-opera-user" v-if="info.mobile || info.email">
            <el-dropdown size="medium" trigger="click" @command="handleCommand">
              <div class="el-dropdown-link">
                <div class="account">{{ info.mobile || info.email }}</div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="password">{{ language == 'en' ? 'Change Password' : '修改密码' }}</el-dropdown-item>
                <el-dropdown-item command="logout">&nbsp;&nbsp;&nbsp;{{ language == 'en' ? 'Log Out' : '退  出' }}&nbsp;&nbsp;&nbsp;</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- 暂时隐藏导航栏订阅入口（已登录态）
            <span class="web-header-content-box-opera-user-link cn-font-bold" @click="subscribe" v-if="language == 'cn'">订阅</span>
            <span class="web-header-content-box-opera-user-link roboto-bold" @click="subscribe" v-else>SUBSCRIBE</span>
            -->
          </div>
          <template v-else>
            <div class="web-header-content-box-opera-user">
              <div class="web-header-content-box-opera-login cn-font-bold" @click="login" v-if="language == 'cn'">
                登录
              </div>
              <div class="web-header-content-box-opera-login roboto-bold" @click="login" v-else>
                SIGN IN
              </div>
              <!-- 暂时隐藏导航栏订阅入口（未登录态）
              <div class="web-header-content-box-opera-subscribe cn-font-bold" @click="subscribe" v-if="language == 'cn'">
                订阅
              </div>
              <div class="web-header-content-box-opera-subscribe roboto-bold" @click="subscribe" v-else>
                SUBSCRIBE
              </div>
              -->
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="info.must_change_password" class="initial-password-notice">
      {{ language === 'en' ? 'Please change your temporary password.' : '请初次登陆后在我的-密码修改中修改密码。' }}
      <el-button type="text" @click="passwordVisible = true">{{ language === 'en' ? 'Change Password' : '修改密码' }}</el-button>
    </div>
    <el-dialog :title="language === 'en' ? 'Change Password' : '修改密码'" :visible.sync="passwordVisible" width="460px" append-to-body @closed="resetPasswordForm">
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-position="top" @submit.native.prevent="submitPassword">
        <el-form-item :label="language === 'en' ? 'New Password' : '新密码'" prop="new_password">
          <el-input v-model="passwordForm.new_password" type="password" show-password autocomplete="new-password" />
        </el-form-item>
        <el-form-item :label="language === 'en' ? 'Confirm New Password' : '确认新密码'" prop="confirm_password">
          <el-input v-model="passwordForm.confirm_password" type="password" show-password autocomplete="new-password" @keyup.enter.native="submitPassword" />
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="passwordVisible = false">{{ language === 'en' ? 'Cancel' : '取消' }}</el-button><el-button type="primary" :loading="passwordSaving" @click="submitPassword">{{ language === 'en' ? 'Submit' : '提交' }}</el-button></span>
    </el-dialog>
    <login-chinese ref="loginChineseRef" @success="loginSuccess"></login-chinese>
    <login-english ref="loginEnglishRef" @success="loginSuccess"></login-english>
  </div>
</template>

<script>
import LoginChinese from "../loginChinese";
import LoginEnglish from "../loginEnglish";
import { userInfo, logoutSystem, changePcPassword } from "@/api";
export default {
  name: "WebHeader",
  components: {
    LoginChinese,
    LoginEnglish
  },
  props: {
    language: {
      type: String,
      default: "en"
    },
    searchVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      info: {},
      passwordVisible: false,
      passwordSaving: false,
      passwordForm: { new_password: '', confirm_password: '' },
      keywords: "",
    };
  },
  computed: {
    passwordRules() {
      const en = this.language === 'en';
      return {
        new_password: [{ required: true, min: 6, max: 16, message: en ? 'Enter a password of 6 to 16 characters' : '请输入6至16位新密码', trigger: 'blur' }],
        confirm_password: [{ validator: (rule, value, callback) => callback(value && value === this.passwordForm.new_password ? undefined : new Error(en ? 'The passwords do not match' : '两次密码不一致')), trigger: 'blur' }]
      };
    }
  },
  created() {
    if (this.$route.query.keywords) {
      this.keywords = decodeURIComponent(this.$route.query.keywords);
    }
    this.getUserInfo();
  },
  watch: {
    '$route.query.login': {
      immediate: true,
      handler(value) {
        if (value !== '1') return;
        this.info = {};
        this.$nextTick(() => {
          this.login();
          const query = { ...this.$route.query };
          delete query.login;
          this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash });
        });
      }
    }
  },
  methods: {
    login() {
      if (this.language == "cn") {
        this.$refs.loginChineseRef.open();
      } else {
        this.$refs.loginEnglishRef.open();
      }
    },
    reloadPage() {
      let links = window.location.href;
      const newUrl = window.location.origin + window.location.pathname;
      if (links.indexOf("report/english") || links.indexOf("report/chinese")) {
        window.location.href = newUrl;
      } else if (links.indexOf("equity/english") || links.indexOf("equity/chinese")) {
        window.location.href = newUrl;
      }
    },
    async getUserInfo() {
      let token = localStorage.getItem("cf40-token");
      if (!token) { this.info = {}; return; }
      try {
        const res = await userInfo({}, this.language === 'en');
        if (localStorage.getItem('cf40-token') !== token) return;
        if (res && res.code === 200) this.info = res.data.user_info;
      } catch (error) { /* 请求层显示错误；过期会话不能保留账号信息。 */ }
      if (!localStorage.getItem('cf40-token')) this.info = {};
    },
    async loginSuccess() {
      await this.getUserInfo();
      if (this.$listeners['session-change']) this.$emit('session-change');
      else this.reloadPage();
    },
    resetPasswordForm() {
      this.passwordForm = { new_password: '', confirm_password: '' };
      if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate();
    },
    submitPassword() {
      if (this.passwordSaving) return;
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) return;
        this.passwordSaving = true;
        try {
          const res = await changePcPassword(this.passwordForm, this.language === 'en');
          if (res && res.code === 200) {
            localStorage.removeItem('cf40-token');
            this.info = {};
            this.passwordVisible = false;
            this.$message.success(this.language === 'en' ? 'Password changed. Please sign in again.' : '密码修改成功，请重新登录。');
            this.$emit('session-change');
            this.login();
          }
        } catch (error) { /* 请求层显示失败信息。 */ }
        finally { this.passwordSaving = false; }
      });
    },
    async logoutHandle() {
      try {
        const res = await logoutSystem(this.language === 'en');
        if (!res || res.code !== 200) return;
        localStorage.removeItem('cf40-token');
        this.info = {};
        this.$message.success(this.language === 'en' ? 'Logged out' : '退出成功');
        if (this.$listeners['session-change']) this.$emit('session-change');
        else window.location.reload();
      } catch (error) { /* 网络异常允许重试，错误由请求层提示。 */ }
    },
    handleCommand(command) {
      if (command === 'password') {
        this.passwordVisible = true;
      } else if (command == "logout") {
        this.logoutHandle();
      }
    },
    subscribe() {
      if (this.language == "cn") {
        this.routerLink('/equity/chinese', true);
      } else {
        this.routerLink('/equity/english', true);
      }
    },
    searchData() {
      if (this.language == "en") {
        if (this.keywords) {
          this.$router.push({ name: 'English', query: { keywords: encodeURIComponent(this.keywords) } });
        } else {
          this.$router.push({ name: 'English' });
        }
      } else {
        if (this.keywords) {
          this.$router.push({ name: 'Index', query: { keywords: encodeURIComponent(this.keywords) } });
        } else {
          this.$router.push({ name: 'Index' });
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.en-font {
  font-family: Georgia;
}
.en-font-bold {
  font-family: Georgia_Bold;
}
.cn-font {
  font-family: HarmonyOS_Sans_Regular;
}
.cn-font-bold {
  font-family: HarmonyOS_Bold;
}
.roboto-light {
  font-family: Roboto_Light;
}
.roboto-bold {
  font-family: Roboto_Bold;
}
.web-header {
  &-top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #ebeef0;
    &-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      &-card {
        display: flex;
        align-items: center;
        &-link {
          color: #757575;
          text-decoration: none;
          display: flex;
          align-items: center;
          &-icon {
            width: 30px;
            line-height: 0;
            display: inline-block;
          }
          &-text {
            margin: 0 20px 0 10px;
            color: #757575;
          }
        }
        &-switch {
          width: 26px;
          height: 26px;
          line-height: 26px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          color: #ffffff;
          text-decoration: none;
          background-color: #ed6f33;
        }
      }
    }
  }
  &-content {
    padding: 30px 0;
    border-bottom: 1px solid #ededed;
    &-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-cn_logo {
        max-width: 206px;
      }
      &-en_logo {
        max-width: 152px;
      }
      &-opera {
        max-width: 620px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-search {
          margin-right: 15px;
          ::v-deep {
            .el-input__inner {
              height: 40px;
              line-height: 40px;
              border-radius: 40px;
              background-color: #E9E9E9;
              &:focus {
                border-color: #ed6f33;
              }
              &::placeholder {
                color: #899BA6;
              }
            }
            .el-input__prefix {
              color: #899BA6;
            }
          }
        }
        &-user {
          display: flex;
          align-items: center;
          .el-dropdown {
            margin-right: 15px;
            .el-dropdown-link {
              display: flex;
            }
            .account {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 110px;
            }
          }
          &-link {
              word-break: keep-all;
              user-select: none;
              cursor: pointer;
              display: flex;
              align-content: center;
              &:hover {
                color: #ed6f33;
              }
            }
        }
        &-login, &-subscribe {
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 10px;
          font-size: 14px;
          border: 2px solid #ed6f33;
          user-select: none;
          white-space: nowrap;
          &:hover {
            border-color: #f38a58;
            background-color: #f38a58;
          }
        }
        &-login {
          color: #ed6f33;
          &:hover {
            color: #ffffff;
          }
        }
        &-subscribe {
          color: #ffffff;
          margin-left: 15px;
          background-color: #ed6f33;
        }
        ::v-deep {
          .el-dropdown {
            cursor: pointer;
            font-size: 16px;
          }
        }
      }
    }
  }
  &.en-font {
    .web-header-content-box-opera-subscribe {
      margin-left: 15px;
    }
    .web-header-content-box-opera-search {
      margin-right: 15px;
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .web-header {
    &-top {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
    &-content {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .web-header {
    &-top {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
    &-content {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
        flex-direction: column;
        &.is-login {
          flex-direction: column;
        }
        &-cn_logo {
          max-width: 150px;
        }
        &-en_logo {
          max-width: 100px;
        }
        &-opera {
          margin-top: 25px;
          width: 100%;
          max-width: 100%;
          &-search {
            width: 60%;
            margin-right: 10px;
            ::v-deep {
              .el-input__inner {
                height: 34px;
                line-height: 34px;
                border-radius: 34px;
              }
            }
          }
          &-user {
            display: flex;
            align-items: center;
            &-link {
              white-space: nowrap;
            }
          }
          &-login, &-subscribe {
            padding: 8px 10px;
            font-size: 12px;
          }
          &-subscribe {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>

<style scoped>
.initial-password-notice { padding: 10px 24px; background: #fff3e8; color: #9c4b1d; text-align: center; font-size: 14px; }
</style>
